import React from 'react';
import { formatCurrency } from '@vastra/utils';

interface PriceDisplayProps {
  price: number;
  compareAtPrice?: number;
  size?: 'sm' | 'md' | 'lg';
}

const sizes: Record<string, string> = {
  sm: 'text-sm',
  md: 'text-lg',
  lg: 'text-2xl',
};

const PriceDisplay: React.FC<PriceDisplayProps> = ({ price, compareAtPrice, size = 'md' }) => (
  <div className="flex items-baseline gap-3" aria-label={`Price: ${formatCurrency(price)}`}>
    <span className={`${sizes[size]} font-medium text-stone-700`}>
      {formatCurrency(price)}
    </span>
    {compareAtPrice && compareAtPrice > price && (
      <>
        <span className="text-sm text-stone-300 line-through" aria-label={`Original price: ${formatCurrency(compareAtPrice)}`}>
          {formatCurrency(compareAtPrice)}
        </span>
        <span className="text-[10px] font-bold text-green-700 uppercase tracking-widest bg-green-50 px-2 py-0.5">
          {Math.round(((compareAtPrice - price) / compareAtPrice) * 100)}% off
        </span>
      </>
    )}
  </div>
);

export default PriceDisplay;
